import { render, staticRenderFns } from "./ManuscriptExportingDialog.vue?vue&type=template&id=0aef9ef4&scoped=true"
import script from "./ManuscriptExportingDialog.vue?vue&type=script&lang=ts"
export * from "./ManuscriptExportingDialog.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptExportingDialog.vue?vue&type=style&index=0&id=0aef9ef4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aef9ef4",
  null
  
)

export default component.exports